import { useState } from 'react';
import { AccountCategory } from '@/interfaces/balanceSheet';

export function useDrilldown() {
  const [drilledDownCategory, setDrilledDownCategory] =
    useState<AccountCategory | null>(null);

  const handleDrilldown = (category: AccountCategory) => {
    setDrilledDownCategory(category);
  };

  const handleBackClick = () => {
    setDrilledDownCategory(null);
  };

  return {
    drilledDownCategory,
    handleDrilldown,
    handleBackClick,
    isDrilledDown: !!drilledDownCategory,
  };
}
